<template>
  <div id="app">
    <div class="over-all" v-if="isSetting"></div>
    <router-view />
  </div>
</template>

<script>
import { URLS } from "fire-wind-water";
export default {
  name: "App",
  data() {
    return {
      isSetting: URLS.getURL("isSetting") || URLS.getHash("isSetting"),
    };
  },
};
</script>
